import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, createSelector, } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { SaldosUsuariosZEList } from "./list/list";
import { SaldosUsuarioZE } from "./saldousuarioze/saldousuarioze";


const tabs = ["saldoZE", "MovimientosZE"];

interface Props {
    match: match<{ tab: "Saldo proveedor ZE" | "Movimientos saldo proveedor ZE" }>
}

export class SaldosUsuarioZEComponent extends React.PureComponent<Props> {
    onRegresar = () => {
        history.go("../");
    }

    tab = (x: Props) => x.match.params.tab;
    tabIndex = createSelector(this.tab, tab => tab ? tabs.indexOf(tab) : 0)

    onTabChange = (x: number) => {
        const tab = this.tab(this.props);
        history.go((tab ? "../" : "./") + tabs[x]);
    }
    
    render() {
        return (
            <div>
                <kea.Tab
                    value={this.tabIndex(this.props)}
                    onChange={this.onTabChange}
                    items={[
                        {
                            title: "Saldo proveedor ZE",
                            iconClass: fa("money"),
                            body: <SaldosUsuarioZE />
                        }, {
                            title: "Movimientos saldo proveedor ZE",
                            iconClass: fa("arrows-alt"),
                            body: <SaldosUsuariosZEList />
                        }
                    ]}
                />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/actividadesusuariosze/edit.tsx